export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/deleteEventYear',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allYears'],
       
    })
